<template>
	<div>
		
		<div class="btn">
			<div class="jiams tj">
				<div>加盟商：</div>
				<Select v-model="query.alliances" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo1">
				        <Option v-for="item in alliances" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="time tj">
				<div>时间：</div>
				<div class="time-xz">
					<DatePicker type="datetime" placeholder="开始时间" v-model='kaishi' style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model='jieshu' style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
				</div>
			</div>
		</div>
       <div class="tongjixinxi">
       	<div class="tongji" >
       		<div class="item1">
       			
       		</div>
       		<div class="item2">
       			<div class="item1-1">
       				总金额（元）
       			</div>
       			<div class="item1-2">
       				实际金额
       			</div>
       			<div class="item1-3">
       				退款金额
       			</div>
       		</div>
       	</div>
       	<div class="tongji">
       		<div class="item1">
       		<Tag color="gold">总计</Tag>
       		</div>
       		<div class="item">
       			<div class="item-title2">{{map.yearMoney/100}}元</div>
       		</div>
       		
       		<div class="item">
       			<div class="item-title2">{{map.yearMoney2/100}}元</div>
       		</div>
       		
       		<div class="item">
       			<div class="item-title2">{{map.yearMoneyRefund/100}}元</div>
       		</div>
       	</div>
       	<div class="tongji">
       		<div class="item1">
       		<Tag color="gold">微信</Tag>
       		</div>
       		<div class="item">
       			<div class="item-title2">{{map.wechatYearMoney/100}}元</div>
       		</div>
       		
       		<div class="item">
       			<div class="item-title2">{{map.wechatYearMoney2/100}}元</div>
       		</div>
       		
       		<div class="item">
       			<div class="item-title2">{{map.wechatYearMoneyRefund/100}}元</div>
       		</div>
       	</div>
       	
       	<div class="tongji">
       		<div class="item1">
       		<Tag color="yellow">支付宝</Tag>
       		</div>
       		<div class="item">
       			<div class="item-title2">{{map.aliapyYearMoney/100}}元</div>
       		</div>
       		<div class="item">
       			<div class="item-title2">{{map.aliapyYearMoney2/100}}元</div>
       		</div>
       		
       		<div class="item">
       			<div class="item-title2">{{map.aliapyYearMoneyRefund/100}}元</div>
       		</div>
       	</div>
       	
       	<div class="tongji">
       		<div class="item1">
       		<Tag color="lime">环保积分</Tag>
       		</div>
       		<div class="item">
       			<div class="item-title2">{{map.xiaojieYearMoney/100}}元</div>
       		</div>
       		<div class="item">
       			<div class="item-title2">{{map.xiaojieYearMoney2/100}}元</div>
       		</div>
       		
       		<div class="item">
       			<div class="item-title2">{{map.xiaojieYearMoneyRefund/100}}元</div>
       		</div>
       	</div>
       	
       </div>
             
	   <Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button> 
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				kaishi:'2019-5-01 00:00:00',
				jieshu:'2019-06-31 00:00:00',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//加盟商列表
				alliances: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: '加盟商id',
						key: 'id'
					},
					{
						title: '加盟商名称',
						key: 'name'
					},
					{
						title: '交易总金额(元)',
						key: 'totalMoney',
						render: (h, params) => {
							return h("div",params.row.totalMoney/100)
						}
					},
					{
						title: '抽成金额(元)',
						key: 'rakeMoney',
						render: (h, params) => {
							return h("div",params.row.rakeMoney/100)
						}
					},
					{
						title: '操作',
						slot: 'action',
						width: 80,
						align: 'center'
					}
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					alliances:[],
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
				},
				map:{
					yearMoney:'--',
					monthMoney:'--',
					dayMoney:'--'
				}
			}
		},
		methods: {
			xiangqing(item){
				let _this=this
				this.$router.push({
					name: 'jm/platform/finance/alliance/earnings/mac',
					query: {
						allianceId: item.id,
						kaishi:_this.query.kaishiTime+'',
						jieshu:_this.query.jieshuTime+''
					}
				})
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			},
			onok(){
				let _this=this
				this.query.page=0
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
					if(ks >=js){
						_this.$Message.error('开始时间必须小于结束时间!');
					}else{
						
						//重新渲染子组件
						this.showPage = false
						this.$nextTick(() => {
							this.showPage = true
						}) 
						_this.ajaxPage()
						_this.queryOperStatistics()
					}
					
				}else{
					
					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onclear(){
				let _this=this
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
				this.queryOperStatistics()
			},
			onchangeSousuo1(){
				
				let _this=this
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
				_this.queryMacs()
			    this.queryOperStatistics()
			},
			onchangeSousuo2(){
				
				let _this=this
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			    this.queryOperStatistics()
			},
			//查询条件
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/alliance/earnings',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.alliances.totalElements
						_this.data6 = data.alliances.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			
			queryAlliances(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/alliance/page1',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let items = data.alliances.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].companyName
							_this.alliances.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			queryOperStatistics(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/jm/statistics/alliance',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.map = data.map
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			

		},
		components: {
			page
		},
		created() {
			let _this=this
			var date = new Date();
			let year=parseInt(date.getFullYear()); //获取完整的年份(4位)
			let month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
			let day=parseInt(date.getDate()); //获取当前日(1-31)
			_this.kaishi=year+'-'+month+'-'+'1'+' 00:00:00'
			_this.query.kaishiTime=year+'-'+month+'-'+'1'+' 00:00:00'
			if(month==12){
				year=year+1
				month=1
				_this.jieshu=year+'-'+month+'-'+'1'+' 00:00:00'
			    _this.query.jieshuTime=year+'-'+month+'-'+'1'+' 00:00:00'
			}else{
				month=month+1
				_this.jieshu=year+'-'+month+'-'+'1'+' 00:00:00'
				_this.query.jieshuTime=year+'-'+month+'-'+'1'+' 00:00:00'
			}
			_this.ajaxPage()
			_this.queryAlliances()
			_this.queryOperStatistics()
		}
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		width: 100%;
		display: flex;
		margin:10px;
		.item1{
			
			width: 100px;
		}
		.item2{
			font-size: 15px;
			display: flex;
			.item1-1{
				color: #fafa00;
			width: 100px;
			}
			.item1-2{
				color: #4ce500;
			width: 100px;
			}
			.item1-3{
				color: #d84800;
			width: 100px;
			}
		}
		.item{
		   
			
			display: flex;
			font-size: 15px;
			font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
			
			.item-title2{
				width: 100px;
			}
		}
	}
	

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/finance/checking/alliance.vue